
import React from "react";
import { Card } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { FileEdit, Link } from "lucide-react";
import { RichTextEditor } from "../RichTextEditor";
import { SourceManager } from "./SourceManager";
import { BlogPostFormData } from "@/types/blog";

interface ContentTabProps {
  formData: BlogPostFormData;
  onChange: (field: string, value: any) => void;
  isLoading?: boolean;
}

export const ContentTab: React.FC<ContentTabProps> = ({
  formData,
  onChange,
  isLoading = false
}) => {
  return (
    <div className="space-y-8">
      <Card className="p-6">
        <div className="flex items-center gap-3 mb-4 border-b pb-4">
          <FileEdit className="h-5 w-5 text-primary" />
          <h3 className="text-lg font-medium">Post Content</h3>
        </div>
        
        <div className="space-y-6">
          <div className="space-y-2">
            <Label htmlFor="title" className="text-base">Title</Label>
            <Input
              id="title"
              placeholder="Blog post title"
              value={formData.title}
              onChange={(e) => onChange("title", e.target.value)}
              disabled={isLoading}
              className="text-base"
            />
          </div>
          
          <div className="space-y-2">
            <Label htmlFor="excerpt" className="text-base">Excerpt</Label>
            <Textarea
              id="excerpt"
              placeholder="Short summary of the post"
              rows={3}
              value={formData.excerpt}
              onChange={(e) => onChange("excerpt", e.target.value)}
              disabled={isLoading}
              className="text-base"
            />
          </div>
          
          <div className="space-y-2">
            <Label htmlFor="content" className="text-base">Content</Label>
            <RichTextEditor
              content={formData.content}
              onChange={(newContent) => onChange("content", newContent)}
              disabled={isLoading}
            />
          </div>
        </div>
      </Card>
      
      <Card className="p-6">
        <div className="flex items-center gap-3 mb-4 border-b pb-4">
          <Link className="h-5 w-5 text-primary" />
          <h3 className="text-lg font-medium">Sources</h3>
        </div>
        
        <SourceManager
          sources={formData.metadata?.sources || []}
          onChange={(sources) => {
            const newMetadata = { ...formData.metadata, sources };
            onChange("metadata", newMetadata);
          }}
          isLoading={isLoading}
        />
      </Card>
    </div>
  );
};
